export default __webpack_public_path__ + "static/DMSans-Regular-ed10d0335ebb8affa3be6a6e033b4f28.woff2";